import {FormControlLabelProps} from '@mui/material/FormControlLabel';
import React, {ChangeEvent} from 'react';
import Checkbox from 'components/inputs/Checkbox';
import {useController, useFormContext} from 'react-hook-form';
import {SetValueOptions} from 'components/hook-form/helpers';
import {useRegisterLabel} from 'common/context/FormContext';

type CheckboxProps = {
   name: string;
   label?: React.ReactNode;
   className?: string;
   disabled?: boolean;
   labelPlacement?: FormControlLabelProps['labelPlacement'];
   autoFocus?: boolean;
   defaultChecked?: boolean;
   value?: any;
};

const HookFormInverseCheckbox = ({name, value, ...restProps}: CheckboxProps) => {
   // const [field, meta, helpers] = useField({name, type: 'checkbox'});

   const methods = useController({
      name,
      // rules: {required: true},
      // defaultValue: '',
   });
   useRegisterLabel(name, restProps.label as string);

   // console.debug('HookFormCheckbox', methods);

   const {
      field: {onBlur, ref, value: checked},
      fieldState: {error: _error},
   } = methods;

   const {setValue} = useFormContext();

   const error = !!_error;
   const _onChange = (e: ChangeEvent<HTMLInputElement>) => {
      // fieldOnChange(e);
      setValue(name, !e.target.checked, SetValueOptions);
      // TODO check touched behaviour
      // if (!meta.touched) {
      //    helpers.setTouched(true);
      // }
   };

   const val = value ?? true;

   return (
      <Checkbox
         onChange={_onChange}
         error={error}
         value={val}
         checked={checked !== val}
         onBlur={onBlur} // notify when input is touched/blur
         // value={value} // input value
         name={name} // send down the input name
         inputRef={ref}
         {...restProps}
      />
   );
};

export default React.memo(HookFormInverseCheckbox);
